const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const Settings = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SETTINGS_REQUEST":
      return { loading: true, error: false, data: [] };
    case "SETTINGS_ERROR":
      return { loading: false, error: true, data: [] };
    case "SETTINGS_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "SETTINGS_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default Settings;
